export default "__VITE_ASSET__BGdUG6ah__"